module.exports = __webpack_public_path__ + "img/T2B_rc_16.1e3ef0ca.png";